import {
    breakList,
    drivingInfo
} from "@/api/break";
import {
    saveOrder
} from "@/api/cart";
export const mixinBreak = {
    methods: {
        // is 是新增查询还是刷新查询
        getDriving(id, is) {
            const me = this,
                // 新增时和刷新查询时跳转方法不同
                go = is ? me.replaceGo : me.go;
            // 用于在列表页面切换到对应位置
            me.$store.state.illegal.drivingId = id;
            // 获取违章信息
            drivingInfo(id).then(() => {
                // 获取成功，刷新数据
                me.$store.dispatch("illegal/drivingList", true);
            }).catch(res => {
                // 用户未支付费用，请求创建订单
                me.saveOrder(res, {
                    driverLicenseId: id,
                    fromCart: false,
                    prepayGoodsList: [{
                        "goodsId": 119,
                        "num": 1
                    }],
                    orderType: 5
                }, '302', is).then(data => {
                    // 用户同意支付
                    go("CartOrderPay",
                        // 跳转到支付页面
                        Object.assign(data, {
                            id: id,
                            orderType: 5
                        })
                    );
                })
            });
        },
        // is 是新增查询还是刷新查询
        getBreakList(params, is) {
            const me = this,
                go = is ? me.replaceGo : me.go,
                id = params.id;
            // 用于在列表页面切换到对应位置
            me.$store.state.illegal.carId = id;
            // 获取违章信息
            breakList({
                cusCarId: id
            }).then(res => {
                // 获取数据成功
                me.goBreakList(go, params, res.data)
            }).catch(res => {
                // 获取数据失败
                // 查不到对应车辆信息时会失败
                if (res.code == 0) {
                    me.goBreakList(go, params, [])
                } else {
                    // 用户未支付费用，请求创建订单
                    me.saveOrder(res, {
                        cusCarId: id,
                        fromCart: false,
                        prepayGoodsList: [{
                            "goodsId": 45,
                            "num": 1
                        }],
                        orderType: 3
                    }, '301', is).then(data => {
                        // 用户同意支付
                        go("CartOrderPay",
                            // 跳转到支付页面
                            Object.assign(data, {
                                params: params,
                                orderType: 3
                            })
                        );
                    })
                }
            });
        },
        // 前往违章列表界面
        goBreakList(go, params, data) {
            // 刷新数据
            this.$store.dispatch("illegal/carList", true);
            // 跳转到违章信息页面
            go('BreakList', Object.assign(params, {
                data: data
            }));
        },
        // 请求创建订单
        // res 后端返回数据
        // payParams 支付参数
        // code 未支付错误码
        // is 是新增查询还是刷新查询
        saveOrder(res, payParams, code, is) {
            const me = this;
            return new Promise((resolve, reject) => {
                if (res.code == code) {
                    // 提示支付
                    me.dialog
                        .confirm({
                            title: "提示",
                            message: "本次查询需要支付1车主币,是否继续查询？",
                            confirmButtonText: '1车主币查询',
                            cancelButtonText: '不查了'
                        }, true)
                        .then(() => {
                            // 创建订单
                            saveOrder(payParams).then(res => {
                                // 订单创建成功
                                resolve(res.data);
                            });
                        }).catch(() => {
                            // 新增时拒接支付处理
                            if (is) {
                                // 用户拒绝支付费用，返回上一页
                                me.backGo();
                            }
                        });
                } else {
                    me.toast.fail(res.msg);
                }
            });
        }
    }
}